import * as React from "react";

import { FormInfo as FormClassificationInfo } from "../../../../../Common/CandyApiClient/ClientDraftInfo/FnsFormInfo";

import { ActualInfoAboutForm } from "./ActualInfoAboutForm";

export interface FormInfoProps {
    name?: string;
    formInfo?: FormClassificationInfo;
}

export function FormInfo(props: FormInfoProps): JSX.Element {
    let name = props.name;
    if (props.formInfo?.okud) {
        name = props.name ?? (props.formInfo?.okud ? `ОКУД ${props.formInfo.okud}` : "");
    } else if (props.formInfo?.knd) {
        name = props.name ?? (props.formInfo?.knd ? `КНД ${props.formInfo.knd}` : "");
    }

    return (
        <div data-tid="formInfo">
            <ActualInfoAboutForm
                name={name}
                relevance={props.formInfo?.relevance}
                relevanceMessage={props.formInfo?.relevanceMessage}
                notice={props.formInfo?.notice}
                periodBeginNew={props.formInfo?.periodBeginNew}
                dateRelease={props.formInfo?.dateRelease}
                reportingDeadlines={props.formInfo?.reportingDeadlines}
                version={props.formInfo?.formVersion}
                periodDescription={props.formInfo?.periodDescription}
            />
        </div>
    );
}
